import API from './apiClient';

export const fetchServices = () => API.get('/services');
export const createService = (newService) => API.post('/services', newService);
export const updateService = (id, updatedService) => API.put(`/services/${id}`, updatedService);
export const deleteService = (id) => API.delete(`/services/${id}`);
